import React from 'react'
import "./Services-css/servicetwo.css"
const ServiceTwo = () => {
  return (
    <div className='service-two-container'>
      <div className='service-two serviceTwo-grid-system'>
        <div className='ser-two-text'>
            Welcome to the future of healthcare
        </div>
      </div>
      
      </div>
  )
}

export default ServiceTwo


